

export class Utils {
    static clientId = "UeZqGEZK2pMpLzM10UE3Z7MgF6ST5REwyc2xEWIh";
    static clientSecret = "T6xl5Sk40QyulB3q29jGW6nBJgkTSlYdz2TI05fAcUcofShqDP0nNruVHyWl8O1diooIU9TqUhsksjET9OOBvhrtvuOIv8KXzQTF0KxtFJ0kePo3ai7L5pCwgxivSlg7";
    static baseUrl = "https://apobackendtools.azurewebsites.net";
    // static baseUrl = "http://localhost:9002";
}